<app-view-item *ngIf="readonly && selected" [text]="getLabel(selected)" [borderless]="borderless"></app-view-item>
<app-view-item *ngIf="readonly && !selected" [text]="''" [borderless]="borderless"></app-view-item>

<nz-select *ngIf="!readonly" #selector nzShowSearch nzServerSearch [nzAllowClear]="true"
  [nzFilterOption]="nzFilterOption" (nzOnSearch)="search($event, 100)"
  (nzOpenChange)="search(''); openChange && openChange.emit($event)" [nzCustomTemplate]="displayTpl"
  (nzScrollToBottom)="loadMore()" [(ngModel)]="value" (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false" [nzBorderless]="borderless" [nzAllowClear]="allowClear"
  [nzBackdrop]="addBackdrop" (keydown)="handleKeyDown($event)" (click)="handleClick($event)"
  [nzDropdownRender]="renderTemplate" class="width-100">
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>

  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="getLabel(selected)" nzCustomContent>
      <div class="dropdown-container">
        <strong>{{ o.code }}</strong>
        :
        <span> {{ o.name }}</span>
      </div>
    </nz-option>
  </ng-container>
</nz-select>

<ng-template #renderTemplate>
  <div class="text-center" *ngIf="!this.notShowInReport">
    <button type="button" nz-button nzType="primary" (click)="addNew()">
      <span nz-icon nzType="plus"></span>
      {{ instantData ? " Add New '" + instantData + "'" : ' Add New' }}
    </button>
  </div>
</ng-template>

<!-- <app-account-code-modal
  #codeModal
  (submitted)="onSubmit($event)"
></app-account-code-modal> -->